// extracted by mini-css-extract-plugin
export var component = "BookModal-module--component--y7jr4";
export var headingDate = "BookModal-module--headingDate--j20Ch";
export var headingGroupName = "BookModal-module--headingGroupName--Gwpf7";
export var list = "BookModal-module--list--UHTry";
export var listItem = "BookModal-module--listItem--PEUyH";